export enum MemberstackStatus {
    CREATED = 'member.created',
    UPDATED = 'member.updated',
    DELETED = 'member.deleted',
    PLAN_ADDED = 'member.plan.added',
    PLAN_CANCELED = 'member.plan.canceled',
    PLAN_UPDATED = 'member.plan.updated',
}